query PayableChartData {
  kpiAgedPayables(orderBy: END_DATE_ASC) {
    nodes {
      title
      charges
      payments
      due
    }
  }
}
